<template>
  <div class="order-wrapper payment-wrapper payment_table" :class="{ 'slide-active': isOpenSummary }">
    <div>
    <FreightBillTable
      :isDedicatedTruck="isDedicatedTruck"
      :editable="enableResubmit && !makeNonEditable"
      :isShipperChargesFeatureEnabled="isShipperChargesFeatureEnabled"
      :indentDetails="payments"
      :depotWiseDetails="depotWiseDetails"
      :indentsCount="indentsCount"
      :isOpenSummary="isOpenSummary"
      :invoiceURL="invoice.einvoice_attachment"
      :isInvoices="true"
      :isFreightBill="isFreightBill"
      :transporterAnnexureEnabled="transporterAnnexureEnabled"
      :invoiceStatus="isInvoiceReturned"
      :invoiceUuid="invoice.invoice_uuid"
      :eInvoiceEnabled="eInvoiceEnabled"
      :extraKmCharge="extraKmCharge"
      @openSliderRight="openSliderRight"
      :freightBillDetails="freightBillDetails"
      :currentInvoiceStatus="currentInvoiceStatus"
      @openSummary="openSummary"
      @loadMore="loadDepotWiseInvoiceDetails"
      @mail-annexure="mailAnnexure"
      @removePaymentFromInvoice="removePaymentFromInvoice"
      ref="freightBillTable"/>
    </div>
    <div class="slideright_drawer top_slideright darkslider" :class="{ openSlideright: isOpenSummary }">
      <div class="slideright_content">
        <div class="slideright_menu">
          <SummarySlide
            :isDedicatedTruck="isDedicatedTruck"
            :indentDetails="payments"
            :invoice="invoice"
            :currentClientGstType="currentClientGstType"
            :editable="isInvoiceReturned"
            :reSubmit="enableResubmit"
            :canCancel="enableCancel"
            :isTaxable="isTaxable"
            :isFreightBill="isFreightBill"
            :freightBillDetails="freightBillDetails"
            :defaultIgst="defaultIgst"
            :canSubmit="enableSubmit"
            :eInvoiceEnabled="eInvoiceEnabled"
            @updateBillToParty="updateBillToParty"
            @updateExtraKm="updateExtraKm"
            @statusUpdate="statusUpdate"
            @close="closeSummary"
            @openRemarks="openRemarksDialog=true"
            />
        </div>
      </div>
    </div>
    <Dialog title="Cancel Invoice" :visible.sync="openRemarksDialog" width="25%"
      class="infodialog topmargin_n centerdialogblock">
      <div class="prompt-message">
        Are you sure you want to cancel Invoice No.{{invoice.invoice_number}}
      </div>
      <div class="cardbox commentarea">
          <textarea rows="3" class="comments" v-model="remarks" placeholder="REMARKS"></textarea>
      </div>
      <div class="actionbtn">
        <button type="btn" class="btn section_pbtn" @click="cancelInvoice"
          :disabled="!remarks.trim()"
          :class="{'disabled': !remarks.trim()}">Cancel</button>
      </div>
    </Dialog>
    <Dialog title="Remove Payment" :visible.sync="removePaymentDialog" width="25%"
      class="infodialog topmargin_n centerdialogblock">
      <div class="prompt-message">
        Are you sure you want to remove the selected payment(s) from Invoice No. {{ invoice.invoice_number }}?
      </div>
      <div class="actionbtn">
        <button type="btn" class="btn section_ebtn" @click="removePaymentDialog = false">No</button>
        <button type="btn" class="btn section_pbtn" @click="confirmRemovePayment">Yes</button>
      </div>
    </Dialog>

    <Dialog title="Remove Payment Status" :visible.sync="removeProgressDialog" width="35%"
      :close-on-click-modal="false" :show-close="removeProgressStatus === 'completed' || removeProgressStatus === 'failed'"
      class="infodialog topmargin_n centerdialogblock">
      <ProgressSteps :steps="removeProgressSteps" :status="removeProgressStatus" :step="removeProgressStep" :error-message="removeProgressError" />
    </Dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { InvoiceStatusUtils } from 'status-utils';
import { invoiceStatus, REMOVE_PAYMENT_STEPS } from '@/constants/payments';
import { getStatusByName, getStatusById } from '@common/lib/payments';
import FreightBillTable from '../../pay-v2/details/FreightBillTable';
import SummarySlide from '../../pay-v2/summary/SummarySlide';
import ProgressSteps from '@/components/common/ProgressSteps';
import { ChargesBy } from 'pando-constants';
import JobStatusPoller from '@/utils/jobStatusPoller';

export default {
  mixins: [JobStatusPoller],
  components: {
    SummarySlide,
    FreightBillTable,
    ProgressSteps,
  },
  data() {
    return {
      noRecords: false,
      isOpenSummary: false,
      isOpenSlideright: false,
      invoiceId: null,
      isEmpty: true,
      makeNonEditable: false,
      extraKm: 0,
      extraKmCharge: 0,
      remarks: '',
      openRemarksDialog: false,
      removePaymentDialog: false,
      pendingRemovePaymentIds: [],
      removeProgressDialog: false,
      removeProgressStatus: null,
      removeProgressStep: 0,
      removeProgressError: null,
      removeProgressSteps: REMOVE_PAYMENT_STEPS,
    };
  },
  created() {
    this.$store.commit('paymentsV2/initialReset');
    this.$store.commit('paymentsV2/setHasEmpty', true);
  },
  mounted() {
    if (this.$route.params.id) {
      this.invoiceId = this.$route.params.id;
      this.loadInvoiceMeta();
      this.getInvoiceApprovalSettings();
    }
    if (this.$route.query.added_orders) {
      const orders = this.$route.query.added_orders;
      const count = orders.split(',').length;
      this.$successMessage({
        header: 'Payment(s) Added',
        message: `${count} new payment${count > 1 ? 's were' : ' was'} successfully added. (${orders})`,
      });
    }
  },
  beforeDestroy() {
    this.$store.commit('paymentsV2/clearDepotDetails', {});
  },
  computed: {
    ...mapGetters({
      invoiceDetails: 'paymentsV2/invoiceDetails',
      dedicatedTruckMaster: 'paymentsV2/dedicatedTruckMaster',
      isLoading: 'paymentsV2/isLoading',
      filter: 'paymentsV2/filter',
      hasEmpty: 'paymentsV2/hasEmpty',
      currentTransporter: 'app/currentTransporter',
      currentClient: 'app/currentClient',
      freightBillDetails: 'paymentsV2/freightBillDetails',
      currentClientConfig: 'app/currentClientConfig',
      totalIndentCount: 'paymentsV2/totalIndentCount',
      depotWiseDetails: 'paymentsV2/depotWiseDetails',
      isShipperChargesFeatureEnabledFromStore: 'paymentsV2/isShipperChargesFeatureEnabled',
    }),
    isDedicatedTruck() {
      return !!(this.dedicatedTruckMaster);
    },
    eInvoiceEnabled() {
      return (this.currentTransporter && this.currentTransporter.e_invoice_verify && this.$hasFeature('e_invoice'));
    },
    isFreightBill() {
      return this.currentClientConfig && this.currentClientConfig.freight_bill
      && this.currentClientConfig.freight_bill.is_enabled;
    },
    payments() {
      return (this.invoiceDetails && this.invoiceDetails.payments) || [];
    },
    currentInvoiceStatus() {
      return (this.invoiceDetails && this.invoiceDetails.data && this.invoiceDetails.data.status);
    },
    currentClientGst() {
      if (this.currentTransporter && this.currentClient) {
        return this.currentTransporter.gst_details.find(
          gst => gst.client_id === this.currentClient.id,
        );
      }
      return undefined;
    },
    currentClientGstType() {
      return (this.currentClientGst && this.currentClientGst.type);
    },
    invoice() {
      const obj = (this.invoiceDetails && this.invoiceDetails.data) || {};
      delete obj.payments;
      return obj;
    },
    isInvoiceReturned() {
      const obj = (this.invoiceDetails && this.invoiceDetails.data) || {};
      if (obj.status === getStatusByName('invoice_returned').id) {
        return true;
      }
      return false;
    },
    indentsCount() {
      return this.totalIndentCount ? this.totalIndentCount : [];
    },
    getCurrentDepotState() {
      return (this.payments && this.payments[0] && this.payments[0].depot.state) || ' ';
    },
    enableResubmit() {
      const featureEnabled = this.$hasFeature('invoice_two_step_approval') ?
        'invoice_two_step_approval' : 'default';
      let result = InvoiceStatusUtils.isValidParent('re_submitted', this.invoice.status, featureEnabled);
      if (this.freightBillDetails) {
        const currentChargeStatuses = this.freightBillDetails
      && this.freightBillDetails.payment_charge_status_count
      && this.freightBillDetails.payment_charge_status_count.map(statusCount => statusCount.status);
        result = currentChargeStatuses && currentChargeStatuses.some(
          status => InvoiceStatusUtils.isValidParent('re_submitted', status, featureEnabled));
      }
      return result && !this.isInvoiceCancelled();
    },
    enableSubmit() {
      return (this.invoice.status === invoiceStatus.CHECKED);
    },
    enableCancel() {
      const featureEnabled = this.$hasFeature('invoice_two_step_approval') ?
        'invoice_two_step_approval' : 'default';
      return InvoiceStatusUtils.isValidParent('invoice_cancelled', this.invoice.status, featureEnabled);
    },
    isTaxable() {
      const [firstElement] = this.payments;
      return firstElement && firstElement.taxable;
    },
    transporterAnnexureEnabled() {
      return this.currentClientConfig && this.currentClientConfig.payment_settings
      && this.currentClientConfig.payment_settings.transporter_annexure_enabled;
    },
    defaultIgst() {
      return (this.currentClientGst && this.currentClientGst.percentage) || 0;
    },
    isShipperChargesFeatureEnabled() {
      // PAN-40066: drives column visibility — based on invoice-level flag only.
      // Feature flag controls new invoice creation, not display of existing invoices.
      return !!this.isShipperChargesFeatureEnabledFromStore;
    },
  },
  methods: {
    async loadInvoiceMeta() {
      if (this.invoiceId) {
        await this.$store.dispatch('paymentsV2/getInvoiceMeta', {
          invoiceId: this.invoiceId,
        });
      }
    },
    async getInvoiceApprovalSettings() {
      if (this.invoiceId) {
        await this.$store.dispatch('paymentsV2/getInvoiceLevelApprovalSettings',
          { invoiceId: this.invoiceId });
      }
    },
    isInvoiceCancelled() {
      return (this.invoice.status === InvoiceStatusUtils.getStatusObjByName('invoice_cancelled').id);
    },
    async loadDepotWiseInvoiceDetails($state, depotId) {
      try {
        if (this.invoiceId && this.depotWiseDetails && this.depotWiseDetails[depotId]) {
          let currentDepot = this.depotWiseDetails[depotId];
          const pageLimit = 25;
          const result = await this.$store.dispatch('paymentsV2/getDepotWiseInvoiceDetail', {
            invoiceId: this.invoiceId,
            params: { page_number: currentDepot.page_number,
              page_limit: pageLimit,
              depot_id: depotId },
          });
          if (result && result.error) {
            this.$errorMessage({ message: result.error });
            $state.complete();
          }
          currentDepot = this.depotWiseDetails[depotId];
          if ($state) {
            if (currentDepot.has_empty) {
              $state.complete();
            } else {
              $state.loaded();
            }
          }
        } else {
          $state.complete();
        }
      } catch (error) {
        $state.complete();
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    openSummary() {
      this.isOpenSummary = true;
      setTimeout(() => {
        this.makeNonEditable = true;
      }, 500);
    },
    closeSummary() {
      this.isOpenSummary = false;
      setTimeout(() => {
        this.makeNonEditable = false;
      }, 500);
    },
    openSliderRight(value) {
      this.isOpenSlideright = value;
    },
    async statusUpdate(statusName, modifiedData) {
      try {
        const placeOfSupply = modifiedData && modifiedData.bill_to_party;
        const statusObj = getStatusByName(statusName);
        const statusId = statusObj.id || statusObj;
        let result;
        if (statusName === getStatusById(10).name) {
          const data = {
            status: statusId,
          };
          result = await this.$store.dispatch('paymentsV2/setInvoiceToCancel', {
            invoiceId: this.invoice.id,
            data,
          });
        } else {
          const data = {
            status: statusId,
            extra_km: this.extraKm ? Number(this.extraKm) : 0,
            bill_to_party: this.invoice.bill_to_party || '',
            bill_to_party_id: this.invoice.bill_to_party_id || '',
            ...modifiedData,
            sez_enabled: this.invoice.sez_enabled || false,
            tax: this.invoice.tax,
          };
          if (this.invoice.status === 4) {
            result = await this.$store.dispatch('paymentsV2/setInvoiceStatus', {
              invoiceId: this.invoice.id,
              data,
            });
          }
        }
        if (result === 'Accepted') {
          const invoiceDetail = this.invoiceDetails;
          invoiceDetail.data.status = statusId;
          const statusLabel = getStatusByName(statusName).label;
          this.$successMessage({ message: this.$getSuccess('INVOICE_STATUS_CHANGE', {
            firstArgument: statusLabel }) });
          this.$store.commit('paymentsV2/setInvoiceDetails', invoiceDetail);
          if (statusName === getStatusById(10).name) {
            this.$router.push({ name: 'payments' });
          } else {
            this.$router.push({ name: 'invoices' });
          }
        } else if (result && result.error) {
          this.$errorMessage({ message: result.error });
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('STATUS_UPDATE_FAILURE') });
      }
    },

    constructUpdateChargesPayload() {
      const resultArray = [];
      Object.keys(this.tempChargeList).forEach((consigneeId) => {
        const currentConsigneeCharges = this.tempChargeList[consigneeId];
        const currentIndentId = currentConsigneeCharges.paymentId;
        delete currentConsigneeCharges.paymentId;
        delete currentConsigneeCharges.charges_by;
        delete currentConsigneeCharges.id;
        const obj = Object.assign({ id: currentIndentId, consignee_id: consigneeId }, currentConsigneeCharges);
        resultArray.push(obj);
      });
      return resultArray;
    },

    updateIndentCharges(result, payments, requestedTotal) {
      const details = this.payments;
      this.errorArray = [];
      payments.forEach((payment) => {
        const detailIndex = details.findIndex(val => val.id === payment.id);
        const detail = details[detailIndex];
        if (detailIndex !== -1) {
          detail.consignee_data.forEach((consignee, index) => {
            const paymentResult = result.find(val => val.consignee_id == consignee.id);
            if (paymentResult && paymentResult.status === 200) {
              if (consignee.charges) {
                const chargeIndex = consignee.charges.findIndex(val => val.charges_by === ChargesBy.TRANSPORTER);
                const consigneeUpdatedCharges = this.tempChargeList[consignee.id];
                const oldValues = details[detailIndex].consignee_data[index].charges[chargeIndex];
                details[detailIndex].consignee_data[index].charges[chargeIndex] = Object.assign(oldValues, consigneeUpdatedCharges);
              }
            } else {
              this.errorArray.push(consignee.id);
            }
          });
        }
      });
      const dummyObj = this.invoiceDetails;
      dummyObj.payments = details;
      this.$store.commit('paymentsV2/replaceInvoiceDetails', dummyObj);
      this.$store.commit('paymentsV2/setTotalTransporterCharges', requestedTotal);
      return true;
    },
    updateBillToParty(data) {
      if (data) {
        this.invoice.bill_to_party = data.billToParty;
        this.invoice.bill_to_party_id = data.billToPartyId;
        this.invoice.sez_enabled = data.sez;
        this.invoice.tax = {
          ...this.invoice.tax,
          igst: data.igst,
          cgst: data.igst / 2,
          sgst: data.igst / 2,
          destination: data.recipientState,
          intra_state: data.isIntraState,
        };
      }
    },
    updateExtraKm(data) {
      this.extraKm = data;
      const totalExtraKmCharge = this.extraKm * this.dedicatedTruckMaster.per_km_rate;
      this.extraKmCharge = (totalExtraKmCharge / this.payments.length).toFixed(2);
      let tempPayments = this.payments;
      let transporterTotal = 0;
      if (Number(this.extraKmCharge) || Number(this.extraKmCharge) === 0) {
        tempPayments = tempPayments.map((indent) => {
          const indentTemp = indent;
          indentTemp.consignee_data = indentTemp.consignee_data && indentTemp.consignee_data.map((consignee) => {
            const consigneeTemp = consignee;
            consigneeTemp.charges = consigneeTemp.charges && consigneeTemp.charges.map((charge) => {
              const chargeTemp = charge;
              if (chargeTemp.charges_by === ChargesBy.TRANSPORTER) {
                const initialExtraKmCharge = chargeTemp.extra_km_charge;
                chargeTemp.total_amount += Number((this.extraKmCharge - initialExtraKmCharge).toFixed(2));
                chargeTemp.extra_km_charge = Number(this.extraKmCharge);
                transporterTotal += chargeTemp.total_amount;
              }
              return chargeTemp;
            });
            return consigneeTemp;
          });
          return indentTemp;
        });
        this.$store.commit('paymentsV2/setTotalTransporterCharges', (transporterTotal));
      }
      this.$store.commit('paymentsV2/replaceIndentDetails', tempPayments);
    },
    async mailAnnexure() {
      try {
        const invoiceId = this.invoiceId;
        const result = await this.$store.dispatch('paymentsV2/mailAnnexure', { invoiceId });
        if (result.data) {
          this.$successMessage({ message: result.data.message });
        } else if (result.error) {
          this.$errorMessage({ message: result.error });
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('GENERAL_ERR') });
      }
    },
    async addComment(comment) {
      let isSuccess = false;
      try {
        const result = await this.$store.dispatch('paymentsV2/addInvoiceComment', {
          invoiceId: this.invoiceDetails.data.id,
          message: comment,
          isReturnedComment: true,
          isCanceledComment: true,
        });
        if (!result) {
          this.$errorMessage({ message: this.$getErr('COMMENT_ADD_FAILURE') });
        } else {
          isSuccess = true;
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('COMMENT_ADD_FAILURE') });
      }
      return isSuccess;
    },
    async cancelInvoice() {
      this.openRemarksDialog = false;
      const success = await this.addComment(this.remarks);
      if (success) {
        await this.statusUpdate(getStatusById(10).name);
      }
    },

    async removePaymentFromInvoice(paymentIds) {
      this.pendingRemovePaymentIds = paymentIds;
      this.removePaymentDialog = true;
    },
    async confirmRemovePayment() {
      this.removePaymentDialog = false;
      this.removeProgressStatus = null;
      this.removeProgressStep = 0;
      this.removeProgressError = null;
      this.removeProgressDialog = true;
      await this.$nextTick();
      this.removeProgressStatus = 'processing';
      try {
        const result = await this.$store.dispatch('paymentsV2/removePaymentFromInvoice', {
          invoiceId: this.invoiceId,
          paymentIds: this.pendingRemovePaymentIds,
        });
        if (!result || result.error) {
          this.removeProgressError = (result && result.error) || 'Failed to queue removal request.';
          this.removeProgressStatus = 'failed';
          return;
        }
        this.removeProgressStep = 1;
        this.pollJobStatus({
          action: 'paymentsV2/checkPaymentJobStatus',
          params: { invoiceId: this.invoiceId, redisKey: result.redisKey },
          onProcessing: (step) => { if (step != null) this.removeProgressStep = step; },
          onCompleted: async () => {
            this.removeProgressStep = this.removeProgressSteps.length;
            await this.$nextTick();
            this.removeProgressStatus = 'completed';
            this.$refs.freightBillTable.selectedIndents = [];
            this.$store.commit('paymentsV2/initialReset');
            this.$store.commit('paymentsV2/setHasEmpty', true);
            await this.loadInvoiceMeta();
            setTimeout(() => { this.removeProgressDialog = false; }, 1000);
          },
          onFailed: (errMsg) => {
            this.removeProgressError = errMsg || 'Failed to remove payment. Please try again.';
            this.removeProgressStatus = 'failed';
          },
        });
      } catch (error) {
        this.removeProgressError = error.message || 'An unexpected error occurred.';
        this.removeProgressStatus = 'failed';
      } finally {
        this.pendingRemovePaymentIds = [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.prompt-message {
  margin: 5px 5px 5px 0px;
  padding: 5px 5px 5px 0px;
}
.btn:disabled {
  opacity: 0.4;
}
</style>
